import { hooks } from '@adc/ui-core'
import { useInfiniteScroll } from './infiniteScroll'
import useWindowDimensionsHook from './useWindowDimensionsHook'
const { useStripePayment } = hooks
export { useWindowDimensionsHook, useInfiniteScroll, useStripePayment }
